import _ from 'underscore';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'vend... Remove this comment to see the full error message
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

import DiscussionAnswer from 'bundles/groups-dashboard-content/models/DiscussionAnswer';
import DiscussionLearner from 'bundles/groups-dashboard-content/models/DiscussionLearner';

const createUserCourseItemQuestionIdKey = (userId: string, courseItemQuestionId: string) => {
  return [userId, courseItemQuestionId].join('~');
};

/**
 * Fluxible Store to serve Discussions: loads learners, answers
 */
const DiscussionGradingStore = createStore({
  storeName: 'DiscussionGradingStore',

  initialize() {
    this.reset();
  },

  reset() {
    this.topLevelAnswersByUserCourseItemQuestionId = {};
    this.learners = {};
  },

  getLearners() {
    return this.learners;
  },

  getAnswers(userId: string, courseItemQuestionId: string, page: $TSFixMe) {
    const key = createUserCourseItemQuestionIdKey(userId, courseItemQuestionId);

    return (
      this.topLevelAnswersByUserCourseItemQuestionId[key] && this.topLevelAnswersByUserCourseItemQuestionId[key][page]
    );
  },
});

DiscussionGradingStore.handlers = {
  LOAD_ANSWERS_WITH_COMMENTS({ response, questionId, page, userId }: $TSFixMe) {
    const key = createUserCourseItemQuestionIdKey(userId, questionId);
    const topLevelAnswers = response.elements.map((reply: $TSFixMe) => new DiscussionAnswer(reply));

    _(response.linked['onDemandDiscussionPromptAnswers.v1']).each((comment) => {
      _(topLevelAnswers).each((answer) => {
        if (answer.courseItemForumAnswerId === comment.parentCourseItemForumAnswerId) {
          answer.addComment(new DiscussionAnswer(comment));
        }
      });
    });

    _(response.linked['onDemandSocialProfiles.v1']).each((socialProfile) => {
      this.learners[socialProfile.userId] = new DiscussionLearner(socialProfile);
    });

    if (!this.topLevelAnswersByUserCourseItemQuestionId[key]) {
      this.topLevelAnswersByUserCourseItemQuestionId[key] = [];
    }

    this.topLevelAnswersByUserCourseItemQuestionId[key][page] = topLevelAnswers;

    this.emitChange();
  },

  LOAD_COMMENT_PAGES({ response, userId, userForumAnswerId, questionId }: $TSFixMe) {
    const key = createUserCourseItemQuestionIdKey(userId, questionId);
    const pagesOfTopLevelAnswers = this.topLevelAnswersByUserCourseItemQuestionId[key];

    _(response.linked['onDemandSocialProfiles.v1']).each((socialProfile) => {
      this.learners[socialProfile.userId] = new DiscussionLearner(socialProfile);
    });

    const topLevelAnswerOfComments = _(
      pagesOfTopLevelAnswers.map((pageOfTopLevelAnswers: $TSFixMe) => {
        if (pageOfTopLevelAnswers) {
          return pageOfTopLevelAnswers.map((topLevelAnswer: $TSFixMe) => topLevelAnswer);
        } else {
          return [];
        }
      })
    )
      .flatten()
      .filter((topLevelAnswer) => !!topLevelAnswer)
      .find((topLevelAnswer) => topLevelAnswer.id === userForumAnswerId);

    _(response.elements).each((comment) => {
      topLevelAnswerOfComments.addComment(new DiscussionAnswer(comment));
    });

    this.emitChange();
  },
};

export default DiscussionGradingStore;
